export const _convertObjectToQuery = obj => {
  let query = '';
  for (let key in obj) {
    if (obj[key] !== undefined) {
      if (Array.isArray(obj[key])) {
        obj[key].forEach(value => {
          if (value !== undefined) {
            if (query) {
              query += `&${key}=${value}`;
            } else {
              query += `${key}=${value}`;
            }
          }
        });
      } else {
        if (query) {
          query += `&${key}=${obj[key]}`;
        } else {
          query += `${key}=${obj[key]}`;
        }
      }
    }
  }
  return query;
};
export const checkPermission = (listPermissionOfUser ,  permissionId) =>{
  return listPermissionOfUser.includes(permissionId);
}

